<template>
  <AppHeader />
  <slot />
</template>

<script setup lang="ts">
import AppHeader from "@/components/shared/AppHeader/AppHeader.vue";
</script>
